/**
 * Error class for an API response outside the 200 range
 *
 * @class ApiError
 * @access public
 * @param {number} status     - the status code of the API response
 * @param {string} statusText - the status text of the API response
 * @param {object} response   - the parsed JSON response of the API server if the
 *                              'Content-Type' header signals a JSON response
 */
export class ApiError extends Error {
  status: number;

  statusText: string;

  response: object;

  headers: Headers;

  constructor(
    status: number,
    statusText: string,
    response: object,
    headers: Headers,
  ) {
    super(`${status} - ${statusText}`);
    this.name = 'ApiError';
    this.status = status;
    this.statusText = statusText;
    this.response = response;
    this.headers = headers;
  }
}
